import { render } from "./VerifyPassword.vue?vue&type=template&id=15e5dd94"
import script from "./VerifyPassword.vue?vue&type=script&lang=js"
export * from "./VerifyPassword.vue?vue&type=script&lang=js"
script.render = render

export default script